import * as dat from "lil-gui";
import { isHrefExist } from "./parse-url";

export const parametersGUI = {
  count: 100000,
  size: 0.01,
  radius: 5,
  branches: 3,
  spin: 1,
  randomness: 0.2,
  randomnessPower: 3,
  insideColor: "#ff6030",
  outsideColor: "#1b3984",
};

export const createGUI = (generateGalaxy) => {
  if (!isHrefExist("debug")) {
    return;
  }

  createGUIParameters(generateGalaxy);
};

export const createGUIParameters = (generateGalaxy) => {
  const gui = new dat.GUI();
  gui
    .add(parametersGUI, "count")
    .min(100)
    .max(1000000)
    .step(100)
    .onFinishChange(generateGalaxy);
  gui
    .add(parametersGUI, "size")
    .min(0.001)
    .max(0.1)
    .step(0.001)
    .onFinishChange(generateGalaxy);
  gui
    .add(parametersGUI, "radius")
    .min(0.01)
    .max(20)
    .step(0.01)
    .onFinishChange(generateGalaxy);
  gui
    .add(parametersGUI, "branches")
    .min(2)
    .max(20)
    .step(1)
    .onFinishChange(generateGalaxy);
  gui
    .add(parametersGUI, "spin")
    .min(-5)
    .max(5)
    .step(0.001)
    .onFinishChange(generateGalaxy);
  gui
    .add(parametersGUI, "randomness")
    .min(0)
    .max(2)
    .step(0.001)
    .onFinishChange(generateGalaxy)
    .name("Dispersion range");
  gui
    .add(parametersGUI, "randomnessPower")
    .min(1)
    .max(10)
    .step(0.001)
    .onFinishChange(generateGalaxy)
    .name("Dispersion");
  gui.addColor(parametersGUI, "insideColor").onFinishChange(generateGalaxy);
  gui.addColor(parametersGUI, "outsideColor").onFinishChange(generateGalaxy);
};
